<!-- a form to handle general information for campaigns and flights 
  This form all general information of a campaign or flight
   Fields as mentioned in the PRD -> 
    1. Campaign Name (nomenclature: agency-advertiser-quarter-year-cmp) db -name
    2. Campaign ID (system generated) db campaign_id
    3. Description (include any campaign-specific notes) db- description
    4. Start/End dates and times (with time zone) db -
    5. Budget ($)
    6. CPM ($) db - target_price
    7. Advertiser Name/ID (preloaded, add Multiple)
    8. Agency Name/ID (preloaded)
    9. Endpoint (preloaded DSP/SSP)
    10. Execution (Direct / PMP)
    Deal ID 
    Endpoint URL
    Seat (# typically specified for a DSP connected via a DSP aggregator)
    Max Bid Floor (takes precedence over the value specified under Demand Partner Dashboard) 

    Parameters->
    isFlight => to determine if form is for flight or campaign
    endLimit => end time limit
    startLimit => start time limit 
    BudgetLimit =>  budget limit

    State-> 
    Impressions => a calculation based on budget and CPM
    isDC => if Execution is direct
    isDSP => id endPoint is DSP
-->
<script lang="ts">
  import InputWrapper from "../form/InputWrapper.svelte";
  import PlainInput from "../form/PlainInput.svelte";
  import TextArea from "../form/TextArea.svelte";
  import DatePicker from "../form/DatePicker.svelte";
  import AutoCompleteCombo from "../form/AutoCompleteCombo.svelte";

  // parameters variables
  export let isFlight: boolean = false;
  export let startLimit: Date = new Date();
  export let endLimit: Date = new Date();

  // fields
  export let name = "";
  export let campaign_id = "";
  export let description = "";
  export let start_at = "";
  export let end_at = "";
  export let budget = 0;
  export let target_price = 0;
  export let advertiser: string[] = [];
  export let agency: string[] = [];
  export let endpoint = "";
  export let execution = "";
  export let dealId = "";
  // export let endpointUrl: string = "";

  // state
  let impressions: number = 0;
  let isDC = execution == "Direct";
  let isDSP = execution == "DSP";

  $: impressions =
    budget > 0 && target_price > 0 ? budget * (1000 / target_price) : 0;
  function executionHandler(e) {
    isDC = e.detail?.value == "Direct";
  }
  function endpointHandler(e) {
    isDSP = e.detail?.value == "DSP";
  }
</script>

<div class="w-full flex flex-row gap-2">
  <InputWrapper label="Campaign Name">
    <PlainInput name="name" bind:value={name} />
  </InputWrapper>

  <InputWrapper label="Campaign ID" slim>
    <PlainInput name="campaign_id" bind:value={campaign_id} readonly />
  </InputWrapper>
</div>

<!-- description -->
<div class="flex">
  <InputWrapper label="Campaign Details">
    <TextArea name="description" bind:value={description} />
  </InputWrapper>
</div>

<!-- date times -->
<div class="flex flex-row gap-2">
  <div class="w-full">
    <DatePicker
      label="Start Date"
      name="start_at"
      reset={false}
      initialValue={start_at}
    />
  </div>
  <div class="w-full">
    <DatePicker
      label="End Date"
      name="end_at"
      reset={true}
      initialValue={end_at}
    />
  </div>
</div>

<!-- Budget & impressions -->
<div class="flex flex-row w-full gap-2">
  <InputWrapper label="Budget">
    <PlainInput name="budget" bind:value={budget} prefix="$" />
  </InputWrapper>
  <InputWrapper label="CPM">
    <PlainInput
      name="target_price"
      bind:value={target_price}
      type="number"
      prefix="$"
    />
  </InputWrapper>
  <InputWrapper label="Output Impressions">
    <PlainInput disabled name="impressions" value={impressions} prefix="$" />
  </InputWrapper>
</div>
<div class="flex flex-row w-full gap-2">
  <!-- {#if isDC} -->
  <InputWrapper label="Advertiser Name/ID">
    <AutoCompleteCombo
      entity="advertisers"
      bind:value={advertiser}
      name="advertiser"
      isMulti
      isClearable
      isSearchable
    />
  </InputWrapper>
  <InputWrapper label="Agency Name/ID">
    <AutoCompleteCombo entity="agency" name="agency" bind:value={agency} />
  </InputWrapper>
  <InputWrapper label="Execution">
    <AutoCompleteCombo
      items={["Direct", "PMP"]}
      name="execution"
      value={execution}
      on:change={executionHandler}
    />
  </InputWrapper>
  <!-- {:else} 
        <InputWrapper label="Endpoint">
            <AutoCompleteCombo
                items={["DSP", "SSP"]}
                name="endpoint"
                bind:value={endpoint}
            />
        </InputWrapper>
        {#if isDSP}
            <InputWrapper label="Deal ID">
                <PlainInput name="deal_id" bind:value={dealId} />
            </InputWrapper>
        {/if}
        <InputWrapper label="Endpoint URL">
            <PlainInput name="url_seat" bind:value={endpointUrl} />
        </InputWrapper>
    {/if} -->
</div>
